import { render, staticRenderFns } from "./ChatHaggleIcon.vue?vue&type=template&id=07163cac&"
import script from "./ChatHaggleIcon.vue?vue&type=script&lang=js&"
export * from "./ChatHaggleIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChatHaggleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports